var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileEventAdRsvp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.007 4A2.997 2.997 0 0 1 18 7v9c0 1.657-1.353 3-2.993 3H2.993A2.997 2.997 0 0 1 0 16V7c0-1.657 1.353-3 2.993-3zM9 7l-.117.007a.996.996 0 0 0-.883.99V10.5H4.5v2H8v2.502c0 .512.386.934.883.991L9 16l.117-.007c.5-.057.883-.479.883-.99V12.5h3.5v-2H10V7.998a1 1 0 0 0-.883-.991zm6.756-5c.411 0 .744.333.744.75v.6l-1-.35h-13l-1 .35v-.6c0-.414.341-.75.744-.75zM13.25 0s.663.376.97.639c.277.237.78.561.78.561H3s.552-.309.878-.588c.129-.11.347-.264.533-.389L4.58.11c.1-.067.169-.11.169-.11z"
})));
export default SvgFacebookMobileEventAdRsvp;